import React from 'react';
import { useSelector } from 'react-redux';
import { Route, useRouteMatch } from 'react-router-dom';
import { RootState } from '../features';
import BestFriends from './BestFriends';
import { FriendMessage } from './BestFriends/message/FriendMessage';
import Catalog from './Catalog';
import Chat from './Chat';
import Dream from './Dream';
import Fortune from './Fortune';
import Home from './Home';
import LifeSupports from './LifeSupports';
import MyDesign from './MyDesign';
import { ConfirmMyDesign } from './MyDesign/ConfirmMyDesign';
import Newspaper from './Newspaper';
import Passport from './Passport';
import Reaction from './Reaction';
import Resort from './Resort';
import SettingsRoutes from './Settings';
import { ScreenSwapRoute } from './shared/routes/ScreenSwapRoute';

export const Dashboard: React.FC = () => {
  const { baid } = useSelector((state: RootState) => state.user);
  const routeMatch = useRouteMatch<{ path: string }>();
  if (!baid) {
    return null;
  }

  const { path } = routeMatch;
  return (
    <>
      <Route path={`${path}/home`}>
        <Home />
      </Route>

      {/* Passport */}
      <ScreenSwapRoute path={`${path}/passport`}>
        <Passport />
      </ScreenSwapRoute>

      {/* Dream */}
      <ScreenSwapRoute path={`${path}/dream/history`}>
        <Dream />
      </ScreenSwapRoute>

      {/* My design */}
      <ScreenSwapRoute path={`${path}/my-design`}>
        <MyDesign />
      </ScreenSwapRoute>
      <Route path={`${path}/confirm-my-design`}>
        <ConfirmMyDesign />
      </Route>

      {/* Chat */}
      <ScreenSwapRoute path={`${path}/chat`}>
        <Chat />
      </ScreenSwapRoute>

      {/* Reaction */}
      <ScreenSwapRoute path={`${path}/reaction`}>
        <Reaction />
      </ScreenSwapRoute>

      {/* Best friends */}
      <ScreenSwapRoute path={`${path}/best-friends`}>
        <BestFriends />
      </ScreenSwapRoute>
      <Route path={`${path}/best-friends-message/:id`} component={FriendMessage} />
      <Route path={`${path}/best-friends-message-to-all`} component={FriendMessage} />

      {/* Catalog */}
      <ScreenSwapRoute path={`${path}/catalog`}>
        <Catalog />
      </ScreenSwapRoute>

      {/* Fortune */}
      <Fortune />

      {/* Resort */}
      <ScreenSwapRoute path="/players/resort">
        <Resort />
      </ScreenSwapRoute>

      {/* Life Support */}
      <ScreenSwapRoute path="/players/life-supports">
        <LifeSupports />
      </ScreenSwapRoute>

      {/* Newspaper */}
      <ScreenSwapRoute path="/players/newspaper">
        <Newspaper />
      </ScreenSwapRoute>

      {/* Settings */}
      <SettingsRoutes />
    </>
  );
};
